const Divider = () => <div className="border-gray-200 border-t-[1px] my-4"></div>;
export default Divider;
